import { BottomNavBorder } from './border';
import { BottomNavRoot } from './root';
import { BottomNavTile } from './tile';

export const BottomNav = {
    Root: BottomNavRoot,
    Border: BottomNavBorder,
    Tile: BottomNavTile
};
